const SITE_NAME = 'Secrets Club';
const DEFAULT_IMAGE = 'https://app.secretsclub.ca/good-quiets-evil.jpg';

const setMeta = (selector, attrName, attrValue, content) => {
  if (typeof document === 'undefined') return;
  let element = document.querySelector(selector);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attrName, attrValue);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
};

const setLink = (rel, href) => {
  if (typeof document === 'undefined') return;
  let element = document.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    document.head.appendChild(element);
  }
  element.setAttribute('href', href);
};

export const setPageSeo = ({
  title = 'Secrets Club - Anonymous Confessions & Advice',
  description = 'Secrets Club - truly anonymous confessions and advice.',
  path = '/',
  image = DEFAULT_IMAGE,
  type = 'website',
}) => {
  if (typeof document === 'undefined') return;

  const canonicalUrl = new URL(path, 'https://app.secretsclub.ca').toString();
  const fullTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;

  document.title = fullTitle;
  setLink('canonical', canonicalUrl);
  setMeta('meta[name="description"]', 'name', 'description', description);
  setMeta('meta[property="og:type"]', 'property', 'og:type', type);
  setMeta('meta[property="og:site_name"]', 'property', 'og:site_name', SITE_NAME);
  setMeta('meta[property="og:title"]', 'property', 'og:title', fullTitle);
  setMeta('meta[property="og:description"]', 'property', 'og:description', description);
  setMeta('meta[property="og:url"]', 'property', 'og:url', canonicalUrl);
  setMeta('meta[property="og:image"]', 'property', 'og:image', image);
  setMeta('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary_large_image');
  setMeta('meta[name="twitter:title"]', 'name', 'twitter:title', fullTitle);
  setMeta('meta[name="twitter:description"]', 'name', 'twitter:description', description);
  setMeta('meta[name="twitter:image"]', 'name', 'twitter:image', image);
};

